/**
 * Centralized Wiki URLs for the application
 */
export const WIKI_URLS = {
    /** Main Wiki home page */
    HOME: 'https://wiki.syensqo.com/display/IC/SyGPT+Home',
    /** Release notes page */
    RELEASE_NOTES: 'https://wiki.syensqo.com/display/IC/SyGPT+releases',
    /** Terms of Use document */
    TERMS_OF_USE:"https://syensqosa.sharepoint.com/:w:/r/sites/shdsyensqoai/_layouts/15/Doc.aspx?sourcedoc=%7B62C67DDA-FB13-5215-0E61-65FEFA1932E8%7D&file=New%20SyGPT%20Terms%20of%20use%20-%20April%202025.docx&action=default&mobileredirect=true"
} as const;
